import moment from "moment";

import style from "./ConsultationDateBox.module.css";

export const ConsultationDateBox = ({ date, isActive = false }) => {
  const m = moment(date);
  const display = m.isValid() ? m : moment();

  return (
    <div className={`${style.consultationDateBox} ${isActive ? style.consultationDateBoxActive : ""}`}>
      <span>{display.format("DD MMM")}</span>
      <span>{display.format("YYYY")}</span>
    </div>
  );
};
